"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CART_TEMPLATE_SELECTOR = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require("babel-runtime/helpers/get");

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _Cart2 = require("./../components/cart/Cart");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CART_TEMPLATE_SELECTOR = exports.CART_TEMPLATE_SELECTOR = "[data-cart-template]"; /*
                                                                                       *  Cart Template
                                                                                       *    Scripts for Cart template
                                                                                       *
                                                                                       *  Version:
                                                                                       *    1.0.0 - 2020/05/04
                                                                                       */

var CartTemplate = function (_Cart) {
  (0, _inherits3.default)(CartTemplate, _Cart);

  function CartTemplate() {
    (0, _classCallCheck3.default)(this, CartTemplate);
    return (0, _possibleConstructorReturn3.default)(this, (CartTemplate.__proto__ || Object.getPrototypeOf(CartTemplate)).apply(this, arguments));
  }

  (0, _createClass3.default)(CartTemplate, [{
    key: "onCartFinished",
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, _get3.default)(CartTemplate.prototype.__proto__ || Object.getPrototypeOf(CartTemplate.prototype), "onCartFinished", this).call(this);
                window.location.reload();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCartFinished() {
        return _ref.apply(this, arguments);
      }

      return onCartFinished;
    }()
  }]);
  return CartTemplate;
}(_Cart2.Cart);

//Initialize


$(document).ready($(CART_TEMPLATE_SELECTOR).each(function (e, i) {
  return new CartTemplate($(i));
}));